export const ENTITLEMENT_IDENTIFIERS: Record<string, string> = {
  SOLO: "solo",
  TEAM: "team",
  ENTERPRISE: "enterprise",
};

export const PROFILE_COUNT_LIMITS: Record<string, number> = {
  SOLO: 2,
  TEAM: 6,
  ENTERPRISE: 12,
  DEFAULT: 1,
};

export const PLAN_NAMES: Record<string, string> = {
  solo_monthly: "Solo",
  team_monthly: "Team",
  enterprise_monthly: "Enterprise",
};

export const PLAN_ORIGINAL_PRICES_STRING: Record<string, string> = {
  solo_monthly: "1,299",
  team_monthly: "2,499",
  enterprise_monthly: "3,499",
};

export const PLAN_PRICES_STRING: Record<string, string> = {
  solo_monthly: "399",
  team_monthly: "1,299",
  enterprise_monthly: "1,799",
};

export const PLAN_DESCRIPTIONS: Record<string, string> = {
  solo_monthly: "For clinics with 1-2 dentists.",
  team_monthly: "For clinics with 3-6 dentists.",
  enterprise_monthly: "For clinics with 7+ dentists.",
};

export const PLAN_LIMITS: Record<string, number> = {
  solo_monthly: 2,
  team_monthly: 6,
  enterprise_monthly: 12,
};
